import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fromJS } from 'immutable';

import CallAdaptiveButton from 'flow/components/CallAdaptiveButton';
import IvrActiveProfile from 'flow/components/pbx/ivr/IvrActiveProfile';
import PbxMenuIcon from 'flow/components/pbx/PbxMenuIcon';
import Page from 'flow/components/Setting/Page';
import Loading from 'flow/components/ui-components/Loading';
import NumberWrapper from 'flow/components/ui-components/NumberWrapper';
import useContact from 'flow/hooks/useContact';
import useCustomer from 'flow/hooks/useCustomer';
import { useAppSelector } from 'flow/hooks/useRedux';
import { getIsSinglePaneMode } from 'flow/selectors/selectors';
import { ReferKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { prettyFormatE164Number } from 'flow/utils/call-utils';
import { getCountryCode } from 'flow/utils/extension-utils';

const PbxIvr = () => {
    const history = useHistory();
    const { entityKey: referKey } = useParams<{ entityKey: ReferKey }>();

    const { ownContact } = useContact();
    const { ownCustomer } = useCustomer();

    const referDTO = useAppSelector((state) =>
        state.pbx.getIn(['refers', referKey]),
    );

    const isSinglePaneMode = useAppSelector(getIsSinglePaneMode);

    const activeProfile = referDTO.get('activeProfile');

    if (!referDTO || !activeProfile) {
        return <Loading />;
    }

    const userCountryCode = getCountryCode(ownContact, ownCustomer);
    const callNumber = referDTO.getIn(['number', 'number']);

    return (
        <Page
            header={referDTO.get('description')}
            onClickBack={
                isSinglePaneMode ? () => history.push(routes['pbx']) : undefined
            }
        >
            <div className="flex h-13 items-center justify-between rounded-sm p-2">
                <div className="flex items-center gap-x-3">
                    <PbxMenuIcon iconKey="ivr" />

                    <NumberWrapper>
                        {prettyFormatE164Number(callNumber, userCountryCode)}
                    </NumberWrapper>
                </div>

                {callNumber ? (
                    <div className="flex justify-end">
                        <CallAdaptiveButton
                            phoneNumber={callNumber}
                            transferContact={fromJS({
                                description: referDTO.get('description'),
                                key: referDTO.get('key'),
                            })}
                            bgColor={'bg-gray-200'}
                        />
                    </div>
                ) : null}
            </div>

            <IvrActiveProfile referKey={referKey} />
        </Page>
    );
};

export default PbxIvr;
